import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { CompanyHeaderComponent } from 'app/securities-level/company-header/company-header.component';
import { RevenueExecutiveSummaryComponent } from '../revenue-executive-summary/revenue-executive-summary.component';
import { PricePerformanceComponent } from '../price-performance/price-performance.component';
// tslint:disable-next-line:max-line-length
import { CpmService } from '../../service/cpm.service';
import { StoreService } from '../../service/store.service';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthorizeService } from '../../service/authorize.service';
import { MatMenuTrigger } from '@angular/material';

@Component({
	selector: 'app-executive-summary',
	templateUrl: './executive-summary.component.html',
	styleUrls: ['./executive-summary.component.scss'],
})
export class ExecutiveSummaryComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild(MatMenuTrigger) exesumTrigger: MatMenuTrigger;
	symbolSearch;
	companyProfile;
	securityStatistic;
	signPostin;
	@ViewChild('companyHeaderComponent')
	companyHeaderComponent: CompanyHeaderComponent;
	@ViewChild('revenueExecutiveSummaryComponent')
	revenueExecutiveSummaryComponent: RevenueExecutiveSummaryComponent;
	@ViewChild('pricePerformanceComponent')
	pricePerformanceComponent: PricePerformanceComponent;

	subscription: Subscription;
	print = false;
	pdf = false;
	displayHeader = true;
	symbol;
	yearF56;
	getPrint;
	printFirst = true;
	printPage = false;

	constructor(
		private cpmService: CpmService,
		private store: StoreService,
		private activatedRoute: ActivatedRoute,
		private authorization: AuthorizeService
	) {}

	ngOnInit() {
		// initialChart
		const { symbol } = this.activatedRoute.snapshot.params;
		const { pdf, print } = this.activatedRoute.snapshot.data;
		this.getPrint = print;

		pdf === undefined ? (this.pdf = false) : (this.pdf = pdf);
		print === undefined ? (this.print = false) : (this.print = print);

		if (symbol) {
			this.cpmService.getSecurityProfileNew(symbol);
		}

		this.store.getSecurityProfileNewResultObservable().subscribe(response => {
			if (!response) {
				return;
			}
			this.yearF56 = response['yearF56'];
			this.symbol = response['securitySymbol'];
		});

		if (this.print || this.pdf) {
			this.displayHeader = true;
			this.printPage = true;
		} else {
			this.displayHeader = false;
			this.printPage = false;
		}
	}
	get isUserHasPermission(): Boolean {
		return this.authorization.hasRole('ROLE_USER');
	}

	ngOnDestroy() {}

	exportPrint = function(symbol) {
		return function executiveSummaryPrint() {
			const endcodeSymbol = encodeURIComponent(symbol);
			window.open(`/#/executiveSummary/${endcodeSymbol}`, '_blank', 'width=850px,height=1024px');
		};
	};

	exportPdf = function(symbol) {
		const service = this.cpmService;
		return function executiveSummaryPdf() {
			const endcodeSymbol = encodeURIComponent(symbol);
			service.downloadFile(`${environment.cpmBaseUrl}/pdf/executiveSummary?symbol=${endcodeSymbol}`);
		};
	};

	pupupPrint() {
		if (this.printFirst) {
			this.printFirst = false;
			window.print();
		} else {
			this.printFirst = false;
		}
	}

	exportEmail = function(symbol, service) {
		return function mailsectorPopup() {
			const endcodeSymbol = encodeURIComponent(symbol);
			service.saveExecutiveSummaryPdfFile(endcodeSymbol).then(filename => {
				const subject = 'Executive Summary';
				const downloadUrl = encodeURIComponent(
					`${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
				);
				window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
			});
		};
	};

	exportFunctions() {
		const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
		arrayOfFunctions.set('email', this.exportEmail(this.symbol, this.cpmService));
		arrayOfFunctions.set('print', this.exportPrint(this.symbol));
		arrayOfFunctions.set('pdf', this.exportPdf(this.symbol));
		return arrayOfFunctions;
	}

	ngAfterViewInit() {
		if (this.getPrint) {
			window.setTimeout('window.print()', 3000);
		}
	}
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/executive-summary/executive-summary.component.ts